import {applyMiddleware, createStore, compose} from "redux";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";
import {loadState, RESTORE_STATE, saveState} from "./persistState";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedState = loadState();

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      thunk
    )
  )
);

store.dispatch({type: RESTORE_STATE, payload: persistedState});
store.subscribe(() => saveState(store.getState()));

export default store;



// WEBPACK FOOTER //
// ./src/store.js